import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import Logo from "@/components/Logo";

export default function AuthCallback() {
  const { setUser, fetchTeam } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    (async () => {
      try {
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
          nav("/login", { replace: true });
          return;
        }
        const session_id = decodeURIComponent(m[1]);
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data);
        if (data?.team_id) await fetchTeam();
        window.history.replaceState({}, "", window.location.pathname);
        nav(data.role === "coach" ? "/dashboard" : "/portal", { replace: true });
      } catch {
        nav("/login", { replace: true, state: { error: "Google sign-in failed" } });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "var(--ink-1)" }}>
      <div className="text-center">
        <Logo size="lg" variant="lockup" linkTo={null} dark />
        <div className="mt-4 text-sm text-white/50" data-testid="auth-callback-loading">Signing you in…</div>
      </div>
    </div>
  );
}
